// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 187 ? "search" : chunkId) + "." + {"5":"3f6a09c8","48":"1e195fee","139":"44150ed0","184":"f4942e74","187":"f2b74f02","208":"3b5e41af","233":"c4bdf340","823":"96d82af6","959":"05ea9f87","974":"c155bf76"}[chunkId] + ".chunk.js";
};